<div class="conversation-messages" #messagesContainer>
  <app-empty-conversation-state
    *ngIf="isEmpty"
    (promptSelected)="onPromptSelected($event)">
  </app-empty-conversation-state>

  <div *ngIf="!isEmpty" class="messages-list">
    <ng-container *ngFor="let message of messages">
      <app-chat-message
        [message]="message"
        (retry)="onRetryMessage($event)">
      </app-chat-message>

      <!-- Show audience size warning for assistant messages with small audience -->
      <app-audience-size-message
        *ngIf="message.role === 'assistant' && isSmallAudienceSize(message.audienceSize)"
        [audienceSize]="message.audienceSize"
        [timestamp]="message.timestamp">
      </app-audience-size-message>
    </ng-container>

    <app-typing-indicator *ngIf="isLoading" [text]="loadingText"></app-typing-indicator>
  </div>
</div>
